import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTableColumnHeader, useTableSelectAllCheckbox, VisuallyHidden } from 'react-aria';
import Checkbox from 'client/components/aria/Table/Checkbox/Checkbox';

import styles from './TableSelectAllCell.module.scss';

const TableSelectAllCell = ({ column, state, className, ...props }) => {
    const ref = useRef();
    const isSingleSelectionMode = state?.selectionManager?.selectionMode === 'single';
    const { columnHeaderProps } = useTableColumnHeader(
        { node: column },
        state,
        ref
    );
    const { checkboxProps } = useTableSelectAllCheckbox(state);

    return (
        <th
            className={[
                'govuk-table__cell',
                styles.cell,
                className
            ].join(' ')}
            {...columnHeaderProps}
            ref={ref}
            data-testid={props['data-testid'] ? props['data-testid'] + '.th' : null}
        >
            {isSingleSelectionMode
                ? <VisuallyHidden>{checkboxProps['aria-label']}</VisuallyHidden>
                : <Checkbox
                    {...checkboxProps}
                    variant='xs'
                    data-testid={props['data-testid'] ? props['data-testid'] + '-selectAll' : null}
                />
            }
        </th>
    );
};

TableSelectAllCell.propTypes = {
    column: PropTypes.any,
    state: PropTypes.object,
    className: PropTypes.string,
    'data-testid': PropTypes.string
};

export default TableSelectAllCell;
